import React from "react";

export default function ManageJobCardHero({
  imageSrc,
  title,
  statusLabel,
  statusTone,
  onOpenJob,
  onImageError,
}) {
  return (
    <div className="manage-job-card__hero">
      <img
        src={imageSrc}
        alt={title}
        className="manage-job-card__hero-image"
        onClick={onOpenJob}
        onError={onImageError}
      />
      <div className="manage-job-card__hero-overlay" onClick={onOpenJob} />
      <div className="manage-job-card__hero-top">
        <span className={`manage-job-card__status manage-job-card__status--${statusTone}`}>
          {statusLabel}
        </span>
      </div>
    </div>
  );
}
